import { TcmEncounter } from "../../../api/tcm-encounter";

export type OutreachAction =
  | { type: "add"; status: "Attempted" | "Completed" }
  | { type: "delete"; index: number };

export const createUpdatedEncounterData = (
  encounter: TcmEncounter,
  status: "Attempted" | "Completed",
  action: OutreachAction
): TcmEncounter => {
  if (action.type === "add") {
    const newLogs = [
      ...(encounter.outreachLogs || []),
      { status, timestamp: new Date().toISOString() },
    ];

    return {
      ...encounter,
      outreachStatus: status,
      lastOutreachDate: new Date(),
      outreachLogs: newLogs,
    };
  }

  if (action.type === "delete" && typeof action.index === "number") {
    const newLogs = (encounter.outreachLogs || []).filter((_, i) => i !== action.index);
    const lastLog = newLogs[newLogs.length - 1];
    const newStatus = newLogs.length === 0 ? "Not Started" : lastLog?.status ?? "Not Started";
    const newDate = newLogs.length > 0 && lastLog ? new Date(lastLog.timestamp) : null;

    return {
      ...encounter,
      outreachStatus: newStatus,
      lastOutreachDate: newDate ?? null,
      outreachLogs: newLogs,
    };
  }

  return encounter;
};
